// export const REST_API = 'http://localhost:4000';
// export const REST_API_ENDPOINT = 'http://localhost:4000/webservices';


export const VERSION = '1.08';


export const REST_API = 'https://new-al-ikhtayar.skyniche.website/backend';
export const REST_API_ENDPOINT = 'https://new-al-ikhtayar.skyniche.website/backend/webservices';